<template>
	<div id="Industyrins" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/hyzx.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/hyzx_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>行业</span><span style="color:#D7230C;">资讯</span></div>
					<div class="sm_pub">新闻快讯行业热门</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/hyzx">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="industcenter" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;">
			<div class="induleft">
				<div class="inlfttop">
					<span style="font-size: 18px;font-weight: 800;">今日要闻</span>
					<router-link tag="span" style="display: inline-block;float: right;font-size: 12px;color: lightgray;"
						to="/jryw">
						查看更多&nbsp;>
					</router-link>
				</div>
				<div class="induleftboom">
					<el-carousel height="385px" direction="vertical" indicator-position="none">
						<el-carousel-item v-for="(item,index) in 2" :key="index">
							<router-link tag="div" :to="{path: '/hyzxdetail', query: {id:o.id,title:o.title}}"
								v-for="(o,index) in newsDay[index]" :key="index" class="listindu">
								<div class="listduimg">
									<img style="width: 100%;height: 100%;" v-lazy="o.picture" alt="">
								</div>
								<div class="listdutitle">
									{{o.title}}
								</div>

								</router-link>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="induright">
				<div class="indurightTop">
					<div class="indcw">

					</div>
					<div class="intoplist" v-for="(item,index) in xptjlist" :key="index" :class="{ 'hyzx_hover': hyzxIndex == item.id }" @click="ShowzxChild(item.id)">
						{{item.name}}
					</div>
				</div>
				<div class="indurightboom" v-if="isShowzxChild">
					<div class="inlfbottoms">
						<ul>
							<router-link class="qbess" tag="li" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}"v-for="(item,index) in qbe" :key="index"> {{item.title}}</router-link>
						</ul>
					</div>
					<div class="inlfbottoms">
						<ul>
							<router-link tag="li" class="qbess" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}"v-for="(item,index) in qbe1" :key="index"> {{item.title}}</router-link>
						</ul>
					</div>
					<div class="inlfbottoms">
						<ul>
							<router-link tag="li" class="qbess" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}"v-for="(item,index) in qbe2" :key="index"> {{item.title}}</router-link>
						</ul>
					</div>
				</div>
				<div class="indurightboom" v-if="!isShowzxChild">
					<div class="inbolft">
						<div class="inlfttop">
							<span style="color: red;font-size: 18px;font-weight: 800;">订单播报</span>
							<router-link tag="span"
								style="display: inline-block;float: right;font-size: 12px;color: lightgray;" to="/ddbb">
								查看更多&nbsp;>
							</router-link>
						</div>

						<div class="inlfbottom">
							<ul>
								<router-link class="qbess"  tag="li" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}" v-for="(item,index) in ddbblist" :key="index"> {{item.title}}</router-link>
							</ul>
						</div>
					</div>
					<div class="inbolft">
						<div class="inlfttop">
							<span style="color: red;font-size: 18px;font-weight: 800;">船舶工程</span>
							<router-link tag="span"
								style="display: inline-block;float: right;font-size: 12px;color: lightgray;" to="/cbgc">
								查看更多&nbsp;>
							</router-link>
						</div>

						<div class="inlfbottom">
							<ul>
								<router-link class="qbess"  tag="li" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}"v-for="(item,index) in cbgclist" :key="index"> {{item.title}}</router-link>
							</ul>
						</div>
					</div>
					<div class="inbolft">
						<div class="inlfttop">
							<span style="color: red;font-size: 18px;font-weight: 800;">海洋工程</span>
							<router-link tag="span"
								style="display: inline-block;float: right;font-size: 12px;color: lightgray;" to="/hygc">
								查看更多&nbsp;>
							</router-link>
						</div>

						<div class="inlfbottom">
							<ul>
								<router-link class="qbess"  tag="li" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}" v-for="(item,index) in hygclist" :key="index"> {{item.title}}</router-link>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				ddbblist: '',
				cbgclist: '',
				hygclist: '',
				newsDay: '',
				isShowzxChild:false,
				hyzxIndex:'',
				qbe:'',
				qbe1:'',
				qbe2:'',
			}
		},
		methods: {
			async ShowzxChild(val){
				this.hyzxIndex = val
				let res = await http.post('api/Common/index',{
					model: 'industry',
					type: 'content',
					mid: '7',
					fid: val,
					rows_limit: '20'
				})
				this.qbe  = res.data.data.list.data.splice(0,6)
				this.qbe1 = res.data.data.list.data.splice(0,6)
				this.qbe2 = res.data.data.list.data.splice(0,6)
				this.isShowzxChild = true
			},
		},
		async mounted() {
			let res = await http.post('api/industry/getSort')
			this.xptjlist = res.data.data

			let res1 = await http.post('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				rows_limit: '5',
				fid: '1'
			})
			this.ddbblist = res1.data.data.list.data

			let res2 = await http.post('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				fid: '4',
				rows_limit: '5'
			})
			this.cbgclist = res2.data.data.list.data

			let res3 = await http.post('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				fid: '5',
				rows_limit: '5'
			})
			this.hygclist = res3.data.data.list.data

			let res4 = await http.post('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				fid: '36',
				rows_limit: '6'
			})
			let xpList = res4.data.data.list.data
			let newArr = [
				[],
				[],
			]
			xpList.forEach((item, index) => {
				if (index < 2) {
					newArr[0].push(item)
				} else if (index >= 2 && index < 4) {
					newArr[1].push(item)
				}
			})
			this.newsDay = newArr
		}
	}
</script>

<style>
	#Industyrins {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	.industcenter {
		width: 100%;
		height: 450px;
		margin-top: 10px;
	}

	.induleft {
		width: 250px;
		height: 450px;
		float: left;
		margin-left: 15px;
	}

	.induright {
		width: 920px;
		height: 450px;
		float: left;
		margin-left: 5px;
	}

	.indurightTop {
		width: 900px;
		height: 150px;
		margin: 0 auto;
	}

	.intoplist:hover {
		box-shadow: #6e6e6e 0px 0px 3px;
	}

	.intoplist {
		width: 9%;
		height: 30px;
		float: left;
		margin: 4px;
		box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
		cursor: pointer;
		border-radius: 2px;
		line-height: 30px;
		font-size: 14px;
		text-align: center;
	}

	.indulefttop {}

	.indcw {
		width: 100%;
		height: 35px;
		/* background-color: antiquewhite; */
	}

	.indurightboom {
		width: 100%;
		height: 270px;
		margin-top: 5px;
	}

	.listindu {
		width: 100%;
		height: 192.5px;
	}

	.listduimg {
		width: 100%;
		height: 150.5px;
	}

	.listdutitle {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		padding-left: 5px;
		background-color: #fff;
		border: 1px solid #6e6e6e;
		box-sizing: border-box;
	}

	.inbolft {
		width: 30%;
		height: 270px;
		margin-left: 3%;
		float: left;
	}

	.inlfttop {
		border-bottom: 3px solid #D7230C;
		height: 50px;
		width: 100%;
		line-height: 50px;
	}

	.inlfbottom {
		width: 100%;
		height: 220px;
	}
	
	.inlfbottoms {
		width: 30%;
		height: 270px;
		float: left;
		margin-left: 1%;
	}
	
	.inlfbottoms>ul {
		padding: 0px;
		margin: 0px;
	}
	
	.qbess:hover{
		color: blue;
		text-decoration: underline;
	}
	
	.inlfbottoms>ul>li {
		list-style: none;
		width: 100%;
		height: 43px;
		line-height: 44px;
		border-bottom: 1px dashed red;
		font-size: 14px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	.inlfbottom>ul {
		padding: 0px;
		margin: 0px;
	}

	.inlfbottom>ul>li {
		list-style: none;
		width: 100%;
		height: 43px;
		line-height: 44px;
		border-bottom: 1px dashed red;
		font-size: 14px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}
	
	.hyzx_hover{
		background: red;
		color: #FFF;
	}
</style>
